export interface IPicture {
    get Guid(): string;
    get OwnerGuid(): string;
    get OwnerIdentity(): string;
    get Base64Image(): string;
    get ImageType(): ImageType;
    get DateTime(): string;
}

export enum ImageType {
    Device = 1,
    Person = 2,
    DevicesGroups = 3
}

export interface IPictureInfo {
    get Guid(): string;
    get DateTime(): string;
    get OwnerGuid(): string;
    get OwnerIdentity(): string; 
}